import React from 'react';
import './labelsPrint.css';

const LabelsPrintableComponent = React.forwardRef(
  ({ summaryData, day, date, formatTimeToAMPM }, ref) => {
    return (
      <div ref={ref} className="printable-container-labels">
        {summaryData.map((list, listIndex) => (
          <div key={listIndex}>
            {list.lines.map((line, lineIndex) => (
              <div key={lineIndex}>
                {line.products.map((product, productIndex) => (
                  <div key={productIndex}>
                    {product.ingredientDetails.map((ingredient, ingredientIndex) => {
                      const fullMixes = Math.floor(ingredient.mixes);

                      return (
                        <React.Fragment key={ingredientIndex}>
                          {ingredient.mixTimes.map((mix, i) => (
                            <div key={ingredientIndex + i} className="label-box">
                              {/* List: {list.listName} {day} {date} <br /> */}
                                {/* Line {line.lineName} <br /> */}
                                {/* <br />
                                <span className="label-line product-name">Product {product.productName} {i + 1} {ingredient.mixTimes[i].type === "rework" ? "Rework" : null}
                                  {ingredient.ingredientCode ? ingredient.ingredientCode : null}
                                </span> */}
                                {/* <br /> */}
                                {/* <br /> */}
                                {/* {ingredient.manufacturerCode && <>Dough {ingredient.manufacturerCode} <br /></>} */}
                              
                              {/* <table>
                                <thead>
                                  <tr>
                                    <th>Mix</th>
                                    <th>Repose</th>
                                    <th>Run</th>
                                    <th>Temp </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{formatTimeToAMPM(ingredient.mixTimes[i].startMixTime)}</td>
                                    <td>{formatTimeToAMPM(ingredient.mixTimes[i].startReposeTime)}</td>
                                    <td>{formatTimeToAMPM(ingredient.mixTimes[i].startTime)}</td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table> */}
                              <table>
                                <thead>
                                  <tr>
                                    <td> Line </td>
                                    <td> {line.lineName} </td>
                                  </tr>
                                  <tr>
                                    <td> Product </td>
                                    <td> {product.productName} {i + 1} {ingredient.mixTimes[i].type === "rework" ? "Rework" : null}
                                      {ingredient.ingredientCode ? ingredient.ingredientCode : null}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      Dough
                                    </td>
                                    <td>
                                      {ingredient.manufacturerCode && <> {ingredient.manufacturerCode} <br /></>}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Mix</td>
                                    <td>{formatTimeToAMPM(ingredient.mixTimes[i].startMixTime)}</td>
                                  </tr>
                                  <tr>
                                    <th>Repose</th>
                                    <td>{formatTimeToAMPM(ingredient.mixTimes[i].startReposeTime)}</td>
                                  </tr>
                                  <tr>
                                    <th>Run</th>
                                    <td>{formatTimeToAMPM(ingredient.mixTimes[i].startTime)}</td>
                                  </tr>
                                  <tr>
                                    <th>Temp </th>
                                    <td></td>
                                  </tr>
                                </thead>
                              </table>
                            </div>

                          ))}
                        </React.Fragment>
                      );
                    })}
                  </div>
                ))}
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  }
);

export default LabelsPrintableComponent;
